<template>
  <div class="pdf-div">
    <div class="title">
      <div class="name">{{pdfName}}</div>
      <div class='oper-icon'>
        <span> 
          <i class="pdf-down" @click="downloadPdf"> <svg-icon icon-class="pdf-download" /> </i>
        </span>

        <span @click.stop="closeWin">
           <i style="color:#FFFFFF !important; cursor: auto;" class="iconfont icon-close-solid mini"></i> 
        </span>

      </div>
    </div>
    <iframe :src="url" frameborder="0" style="width: 100%; height: calc(100% - 35px)"></iframe>
  </div>
</template>

<script>
import { downloadUseForm } from "../../../../common-components/src/utils/fileUtil";
export default {
  name: "PdfPreview",
  props: {
    id: {
      type: Number,
      default: 0
    },
    pdfName: {
      type: String,
      default: ''
    },
    previewUrl: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      url: '',
    }
  },
  mounted() {
    this.previewPdfSource();
  },
  methods: {
    previewPdfSource() {
      this.url = '/pdf/web/viewer.html?file=' + encodeURIComponent(this.previewUrl);
    },
    deletePdf() {
      this.$confirm("确定要删除文件/文件夹？", "确认删除").then(() => {
        this.$api.post("/resapi/tw/resource-file/deleteFiles", { ids: this.id }).then(res => {
          if (res.success) {
            this.$emit("delete")
          } else {
            this.$message.error(res.info ? res.info : "删除失败");
          }
        })


      });
    },
    downloadPdf() {
      this.ucloading.showLoading();
      this.$api.post("/resapi/resource/download/downloadCheck", { ids: this.id }).then(res => {
        this.ucloading.hideLoading();
        if (!res.success) {
          this.$message.error(res.info);
          return;
        }
        downloadUseForm(res.data.downloadUrl, {});
      }).catch(error => {
        this.ucloading.hideLoading();
        console.log(error);
      })
    },
    closeWin() {
      window.close();
    }
  }
}
</script>

<style lang="scss" scoped>
.pdf-div {
  height: 100%;
  .title {
    background: #4d4d4d;
    display: flex;
    justify-content: space-between;
    height: 30px;
    line-height: 30px;

    .oper-icon {
      margin-right: 45px;
      display: flex;
      span {
        background: none;
        width: 32px;
        height: 25px;
        display: block;
        margin-top: 2px;
        border: 1px solid transparent;
        border-radius: 2px;
        color: hsla(0, 0%, 100%, 0.8);
        line-height: 24px;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        cursor: default;
        -webkit-transition-property: background-color, border-color, box-shadow;
        -webkit-transition-duration: 150ms;
        -webkit-transition-timing-function: ease;
        transition-property: background-color, border-color, box-shadow;
        transition-duration: 150ms;
        transition-timing-function: ease;
        &:hover {
          background-color: hsla(0, 0%, 0%, 0.12);
          background-image: linear-gradient(
            hsla(0, 0%, 100%, 0.05),
            hsla(0, 0%, 100%, 0)
          );
          background-clip: padding-box;
          border: 1px solid hsla(0, 0%, 0%, 0.35);
          border-color: hsla(0, 0%, 0%, 0.32) hsla(0, 0%, 0%, 0.38)
            hsla(0, 0%, 0%, 0.42);
          box-shadow: 0 1px 0 hsla(0, 0%, 100%, 0.05) inset,
            0 0 1px hsla(0, 0%, 100%, 0.15) inset,
            0 1px 0 hsla(0, 0%, 100%, 0.05);
        }
      }
    }
    .name {
      margin-left: 30px;
      color: white;
    }
  }
}
</style>